/** TC lander form preserves native identity and concurrency. For Media Devoted | Created By Ciro Autiero */
import { parseVoluumLanderResource } from '@/features/flow-optimizer/tabs/standard/v2/paths/path-items/lander-editor/map-voluum-lander-form';
export interface TcLanderForm {
  originalTags: string[];
  namePostfix: string; url: string; countryCode: string; tagsCsv: string; noteText: string;
  preferredTrackingDomain: string; landerType: 'LANDER' | 'PRELANDER';
  shouldHaveTrackingScript: boolean; numberOfOffers: number; updatedTime: string;
}
export function readTcLander(raw: unknown): TcLanderForm {
  const values = parseVoluumLanderResource(raw);
  const source = raw && typeof raw === 'object' ? raw as Record<string, unknown> : {};
  const stamp = source.updatedTime ?? source.updatedAt;
  if (typeof stamp !== 'string' || !stamp) throw Error('The lander has no update timestamp. Reload before editing.');
  const originalTags = Array.isArray(source.tags) ? source.tags.filter((tag): tag is string => typeof tag === 'string') : [];
  return { ...values, originalTags, updatedTime: stamp };
}
export function tcLanderPayload(values: TcLanderForm) {
  return {
    namePostfix: values.namePostfix.trim(), url: values.url.trim(),
    countryCode: values.countryCode.trim().toUpperCase(), noteText: values.noteText,
    preferredTrackingDomain: values.preferredTrackingDomain.trim(), landerType: values.landerType,
    shouldHaveTrackingScript: values.shouldHaveTrackingScript, numberOfOffers: values.numberOfOffers,
    tags: values.tagsCsv === values.originalTags.join(', ') ? [...values.originalTags]
      : values.tagsCsv.split(',').map((v) => v.trim()).filter(Boolean), updatedTime: values.updatedTime,
  };
}
